import { render, staticRenderFns } from "./UploadsSelect.vue?vue&type=template&id=0aea83d4"
import script from "./UploadsSelect.vue?vue&type=script&lang=js"
export * from "./UploadsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports